import { SubscriptionSummary } from '../../../types/subscription';
import { useSelector } from 'react-redux';
import { selectSubscriptionSummaries } from '../../../store/slices/subscription';
import { colors } from '../../../colors';
import { formatNumber } from '../../../helpers/NumberFormatter';
import AssetIcon from '../../../components/AssetIcon';
import { useUpdateSubscriptionStateMutation } from '../../../store/services/api';
import { selectUserId } from '../../../store/slices/user';

const SubscriptionStates = () => {
  const userId = useSelector(selectUserId);
  const [updateSubscriptionState] = useUpdateSubscriptionStateMutation();
  const allSubscriptions = useSelector(selectSubscriptionSummaries);

  const handleItemPress = async (
    subscriptionId: number,
    updatedValue: boolean,
  ) => {
    await updateSubscriptionState({
      userId,
      subscriptionId,
      isActive: updatedValue,
    });
  };

  return (
    <div
      style={{
        paddingLeft: 16,
        paddingRight: 16,
        marginTop: -5,
        paddingBottom: 32,
        borderBottom: '0.5px solid rgba(80, 80, 80, 0.3)',
      }}
    >
      <p
        style={{
          color: 'white',
          fontWeight: 'bold',
          fontSize: 20,
          marginBottom: 5,
        }}
      >
        Subscription States
      </p>
      <span style={{ color: colors.orange }}>
        When you pause a subscription, the program does not touch the assigned
        balances. This also means if you pause a subscription when it had
        bought, you are at risk of a downwards market.
      </span>
      <div
        style={{
          display: 'grid',
          gap: 16,
          marginTop: 20,
          justifyContent: 'center',
          gridTemplateColumns: 'repeat(3, 1fr)',
        }}
      >
        {allSubscriptions.map((item) => (
          <StateItem
            key={item.id}
            item={item}
            handleItemPress={handleItemPress}
          />
        ))}
      </div>
    </div>
  );
};

const StateItem = ({
  item,
  handleItemPress,
}: {
  item: SubscriptionSummary;
  handleItemPress: (
    subscriptionId: number,
    updatedValue: boolean,
  ) => Promise<void>;
}) => {
  return (
    <div
      style={{
        border: '1px solid gray',
        borderRadius: 8,
        boxShadow: '4px 0px 5px rgba(255, 255, 255, 0.2)',
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <div
          style={{
            color: colors.white,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <AssetIcon baseAsset={item.baseAsset} width={20} height={20} />
          {item.baseAsset} / {item.quoteAsset}
        </div>
        <p style={{ color: colors.white, margin: 0 }}>
          <span style={{ color: colors.gray }}>{item.baseAsset}</span>{' '}
          {item.assetBalance}
        </p>
        <p style={{ color: colors.white, margin: 0 }}>
          <span style={{ color: colors.gray }}>{item.quoteAsset}</span>{' '}
          {formatNumber(item.stableBalance, 2)}
        </p>
      </div>
      <div
        style={{
          height: '90%',
          aspectRatio: 1,
          borderRadius: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: !item.isActive
            ? `${colors.green}5A`
            : `${colors.red}5A`,
          border: !item.isActive
            ? `2px solid ${colors.green}9A`
            : `2px solid ${colors.red}9A`,
          cursor: 'pointer',
        }}
        onClick={() => handleItemPress(item.id, !item.isActive)}
      >
        <span style={{ color: colors.white, fontWeight: 'bold', fontSize: 14 }}>
          {item.isActive ? 'Pause' : 'Resume'}
        </span>
      </div>
    </div>
  );
};

const AccountSubscriptions = () => {
  return (
    <div style={{ padding: 28, paddingTop: 16 }}>
      <SubscriptionStates />
    </div>
  );
};

export default AccountSubscriptions;
